import React from "react";
import { connect } from "react-redux";
import { ProgressBar, Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import { onPressReferralsDropDown } from "../../actions";
import { Link } from "react-router-dom";
import axios from "axios";

class ReferralsCards1 extends React.Component {
  state = {
    categories: [], // To store fetched categories data
  };

  // Fetch categories data from the API when the component mounts
  componentDidMount() {
    axios
      .get("https://brand.aasmo.in/api/admin/getall-category")
      .then((response) => {
        // Update state with the categories data
        this.setState({ categories: response.data.categories });
      })
      .catch((error) => {
        console.error("There was an error fetching the category data:", error);
      });
  }

  render() {
    const { categories } = this.state; // Get the category data from state

    return (
      <div className="card">
        <div className="header">
          <h2>Product Categories</h2>
          <Dropdown as="ul" className="header-dropdown">
            <Dropdown.Toggle variant="success" as="li" id="dropdown-basic">
              <Dropdown.Menu
                as="ul"
                className="dropdown-menu dropdown-menu-right"
              >
                <li>
                  <Link to="#">Action</Link>
                </li>
                <li>
                  <Link to="#">Another Action</Link>
                </li>
                <li>
                  <Link to="#">Something else</Link>
                </li>
              </Dropdown.Menu>
            </Dropdown.Toggle>
          </Dropdown>
        </div>
        <div className="body">
          <ul className="list-unstyled list-referrals">
            {/* Loop through the brands array and display each brand's name */}
            {categories.map((brand, index) => (
              <li key={brand._id}>
                <p>
                  <span className="value"></span>
                  <span className="text-muted float-right">{brand.categoryName}</span>
                </p>
                <ProgressBar
                  className="progress progress-xs progress-transparent custom-color-blue"
                  now={87} // You can update this dynamically as well
                  min={0}
                  max={100}
                />
              </li>
            ))}
          </ul>
        </div>
       
      </div>
    );
  }
}

ReferralsCards1.propTypes = {
  onPressReferralsDropDown: PropTypes.func.isRequired,
};

const mapStateToProps = ({ analyticalReducer }) => ({
  referralsDropDown: analyticalReducer.referralsDropDown,
});

export default connect(mapStateToProps, {
  onPressReferralsDropDown,
})(ReferralsCards1);
